/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkGeruestbauProjectDto } from '../models/work-geruestbau-project-dto';
import { WorkTask } from '../models/work-task';
import { WorkUpdateTaskDto } from '../models/work-update-task-dto';

@Injectable({ providedIn: 'root' })
export class WorkGerustbauV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `geruestbauV2ControllerGetProjectsByInstallationStartDaterange()` */
  static readonly GeruestbauV2ControllerGetProjectsByInstallationStartDaterangePath = '/v2/projects/geruestbau/projects/byInstallationStartDaterange/{fromDate}/{toDate}';

  /**
   * Required permissions: geruestbau:read, geruestbau:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `geruestbauV2ControllerGetProjectsByInstallationStartDaterange()` instead.
   *
   * This method doesn't expect any request body.
   */
  geruestbauV2ControllerGetProjectsByInstallationStartDaterange$Response(
    params: {
      fromDate: string;
      toDate: string;
      businessunitIds?: Array<string>;
      overdue?: boolean;
      abbauNotPlanned?: boolean;
      geplantOrFreigegeben?: boolean;
      sortByGeruestaufbau?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkGeruestbauProjectDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkGerustbauV2Service.GeruestbauV2ControllerGetProjectsByInstallationStartDaterangePath, 'get');
    if (params) {
      rb.path('fromDate', params.fromDate, {});
      rb.path('toDate', params.toDate, {});
      rb.query('businessunitIds', params.businessunitIds, {});
      rb.query('overdue', params.overdue, {});
      rb.query('abbauNotPlanned', params.abbauNotPlanned, {});
      rb.query('geplantOrFreigegeben', params.geplantOrFreigegeben, {});
      rb.query('sortByGeruestaufbau', params.sortByGeruestaufbau, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkGeruestbauProjectDto>>;
      })
    );
  }

  /**
   * Required permissions: geruestbau:read, geruestbau:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `geruestbauV2ControllerGetProjectsByInstallationStartDaterange$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  geruestbauV2ControllerGetProjectsByInstallationStartDaterange(
    params: {
      fromDate: string;
      toDate: string;
      businessunitIds?: Array<string>;
      overdue?: boolean;
      abbauNotPlanned?: boolean;
      geplantOrFreigegeben?: boolean;
      sortByGeruestaufbau?: boolean;
    },
    context?: HttpContext
  ): Observable<Array<WorkGeruestbauProjectDto>> {
    return this.geruestbauV2ControllerGetProjectsByInstallationStartDaterange$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkGeruestbauProjectDto>>): Array<WorkGeruestbauProjectDto> => r.body)
    );
  }

  /** Path part for operation `geruestbauV2ControllerApproveGeruestabbau()` */
  static readonly GeruestbauV2ControllerApproveGeruestabbauPath = '/v2/projects/geruestbau/projects/{id}/approveGeruestabbau';

  /**
   * Required permissions: geruestbau:update, tasks:update, geruestbau:admin, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `geruestbauV2ControllerApproveGeruestabbau()` instead.
   *
   * This method doesn't expect any request body.
   */
  geruestbauV2ControllerApproveGeruestabbau$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkGerustbauV2Service.GeruestbauV2ControllerApproveGeruestabbauPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * Required permissions: geruestbau:update, tasks:update, geruestbau:admin, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `geruestbauV2ControllerApproveGeruestabbau$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  geruestbauV2ControllerApproveGeruestabbau(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.geruestbauV2ControllerApproveGeruestabbau$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

  /** Path part for operation `geruestbauV2ControllerUpdateTask()` */
  static readonly GeruestbauV2ControllerUpdateTaskPath = '/v2/projects/geruestbau/tasks/{id}';

  /**
   * Required permissions: geruestbau:update, geruestbau:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `geruestbauV2ControllerUpdateTask()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  geruestbauV2ControllerUpdateTask$Response(
    params: {
      id: number;
      body: WorkUpdateTaskDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkGerustbauV2Service.GeruestbauV2ControllerUpdateTaskPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * Required permissions: geruestbau:update, geruestbau:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `geruestbauV2ControllerUpdateTask$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  geruestbauV2ControllerUpdateTask(
    params: {
      id: number;
      body: WorkUpdateTaskDto
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.geruestbauV2ControllerUpdateTask$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

  /** Path part for operation `geruestbauV2ControllerAcceptTask()` */
  static readonly GeruestbauV2ControllerAcceptTaskPath = '/v2/projects/geruestbau/tasks/{id}/accept';

  /**
   * Required permissions: geruestbau:accept, geruestbau:update, geruestbau:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `geruestbauV2ControllerAcceptTask()` instead.
   *
   * This method doesn't expect any request body.
   */
  geruestbauV2ControllerAcceptTask$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkGerustbauV2Service.GeruestbauV2ControllerAcceptTaskPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * Required permissions: geruestbau:accept, geruestbau:update, geruestbau:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `geruestbauV2ControllerAcceptTask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  geruestbauV2ControllerAcceptTask(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.geruestbauV2ControllerAcceptTask$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

  /** Path part for operation `geruestbauV2ControllerDeclineTask()` */
  static readonly GeruestbauV2ControllerDeclineTaskPath = '/v2/projects/geruestbau/tasks/{id}/decline';

  /**
   * Required permissions: geruestbau:decline, geruestbau:update, geruestbau:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `geruestbauV2ControllerDeclineTask()` instead.
   *
   * This method doesn't expect any request body.
   */
  geruestbauV2ControllerDeclineTask$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkGerustbauV2Service.GeruestbauV2ControllerDeclineTaskPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * Required permissions: geruestbau:decline, geruestbau:update, geruestbau:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `geruestbauV2ControllerDeclineTask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  geruestbauV2ControllerDeclineTask(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.geruestbauV2ControllerDeclineTask$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

  /** Path part for operation `geruestbauV2ControllerCompleteTask()` */
  static readonly GeruestbauV2ControllerCompleteTaskPath = '/v2/projects/geruestbau/tasks/{id}/complete';

  /**
   * Required permissions: geruestbau:complete, geruestbau:update, geruestbau:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `geruestbauV2ControllerCompleteTask()` instead.
   *
   * This method doesn't expect any request body.
   */
  geruestbauV2ControllerCompleteTask$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkGerustbauV2Service.GeruestbauV2ControllerCompleteTaskPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * Required permissions: geruestbau:complete, geruestbau:update, geruestbau:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `geruestbauV2ControllerCompleteTask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  geruestbauV2ControllerCompleteTask(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.geruestbauV2ControllerCompleteTask$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

  /** Path part for operation `geruestbauV2ControllerAssignTaskToTeam()` */
  static readonly GeruestbauV2ControllerAssignTaskToTeamPath = '/v2/projects/geruestbau/tasks/{id}/team/{teamId}';

  /**
   * Required permissions: geruestbau:assign, geruestbau:update, geruestbau:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `geruestbauV2ControllerAssignTaskToTeam()` instead.
   *
   * This method doesn't expect any request body.
   */
  geruestbauV2ControllerAssignTaskToTeam$Response(
    params: {
      id: number;
      teamId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkGerustbauV2Service.GeruestbauV2ControllerAssignTaskToTeamPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('teamId', params.teamId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * Required permissions: geruestbau:assign, geruestbau:update, geruestbau:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `geruestbauV2ControllerAssignTaskToTeam$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  geruestbauV2ControllerAssignTaskToTeam(
    params: {
      id: number;
      teamId: number;
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.geruestbauV2ControllerAssignTaskToTeam$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

  /** Path part for operation `geruestbauV2ControllerRemoveTeamFromTask()` */
  static readonly GeruestbauV2ControllerRemoveTeamFromTaskPath = '/v2/projects/geruestbau/tasks/{id}/team';

  /**
   * Required permissions: geruestbau:assign, geruestbau:update, geruestbau:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `geruestbauV2ControllerRemoveTeamFromTask()` instead.
   *
   * This method doesn't expect any request body.
   */
  geruestbauV2ControllerRemoveTeamFromTask$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkGerustbauV2Service.GeruestbauV2ControllerRemoveTeamFromTaskPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTask>;
      })
    );
  }

  /**
   * Required permissions: geruestbau:assign, geruestbau:update, geruestbau:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `geruestbauV2ControllerRemoveTeamFromTask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  geruestbauV2ControllerRemoveTeamFromTask(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTask> {
    return this.geruestbauV2ControllerRemoveTeamFromTask$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTask>): WorkTask => r.body)
    );
  }

  /** Path part for operation `geruestbauV2ControllerPrepareGeruestbauInfoPdfForProject()` */
  static readonly GeruestbauV2ControllerPrepareGeruestbauInfoPdfForProjectPath = '/v2/projects/geruestbau/prepareGeruestbauInfoPdfForProject/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `geruestbauV2ControllerPrepareGeruestbauInfoPdfForProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  geruestbauV2ControllerPrepareGeruestbauInfoPdfForProject$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkGerustbauV2Service.GeruestbauV2ControllerPrepareGeruestbauInfoPdfForProjectPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `geruestbauV2ControllerPrepareGeruestbauInfoPdfForProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  geruestbauV2ControllerPrepareGeruestbauInfoPdfForProject(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.geruestbauV2ControllerPrepareGeruestbauInfoPdfForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
